<template>
  <div id="app">
    <headers ></headers>
    <router-view :key="$route.fullPath" />
    <footers v-if="$route.name != 'contents'"></footers>
  </div>
</template>

<script>
import headers from './components/headers'
import footers from './components/footers'

export default {
    name: 'App',
    data() {
        return {
        };
    },
    components:{
        headers,
        footers
    },
}
</script>
<style scoped>
#app {
  min-width: 1460px;
  overflow: auto;
}
/*滚动条样式*/
#app::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
}
#app::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #b2d0ff;
}
#app::-webkit-scrollbar-thumb:hover {
  background: #4d91ff;
  cursor: pointer;
}
#app::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: #edeff5;
}

</style>



// WEBPACK FOOTER //
// src/App.vue